const EDITABLE_SELECTOR =
  'input, textarea, select, [contenteditable=""], [contenteditable="true"], [contenteditable="plaintext-only"]';

function markNoTranslate(element: HTMLElement): void {
  element.setAttribute('translate', 'no');
  element.classList.add('notranslate');
  if (!element.lang) {
    element.lang = 'ko';
  }
}

function guardEditableFields(root: ParentNode): void {
  root.querySelectorAll(EDITABLE_SELECTOR).forEach((node) => {
    if (node instanceof HTMLElement) markNoTranslate(node);
  });
}

function guardAddedNode(node: Node): void {
  if (!(node instanceof HTMLElement)) return;
  markNoTranslate(node);
  guardEditableFields(node);
}

/** Chrome 등 브라우저 번역이 한글 UI를 재번역하지 않도록 문서·동적 노드를 보호한다. */
export function applyBrowserTranslateGuard(): void {
  const { documentElement: html, body } = document;

  html.setAttribute('lang', 'ko');
  html.setAttribute('translate', 'no');
  html.classList.add('notranslate');

  if (body) {
    markNoTranslate(body);
    guardEditableFields(body);
  }

  const root = document.getElementById('root');
  if (root) {
    markNoTranslate(root);
    guardEditableFields(root);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          guardAddedNode(node);
        });
      }
    });

    observer.observe(root, { childList: true, subtree: true });

    if (body) {
      const bodyObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (node === root) return;
            guardAddedNode(node);
          });
        }
      });
      bodyObserver.observe(body, { childList: true });
    }
  }
}
